import type { ReactElement } from 'react';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './routes/router';
import { JobsProvider } from './lib/jobs';

/**
 * Componente raíz de la aplicación.
 *
 * En M1.1 introducimos el router code-based de TanStack. La instancia se
 * define en `routes/router.tsx` y se monta aquí. El gating de auth lo realiza
 * el root route consultando `useAuthStatus()` y redirigiendo según el estado.
 *
 * M2.27: envolvemos en `JobsProvider` para que el store de jobs IA en
 * curso (coach, nutricionista) viva en el nivel root y sobreviva a
 * navegaciones — el banner global lo lee desde AppLayout.
 */
export function App(): ReactElement {
  return (
    <JobsProvider>
      <RouterProvider router={router} />
    </JobsProvider>
  );
}
